import React, { useState } from 'react';
import { FaHeart } from 'react-icons/fa';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileAlt } from '@fortawesome/free-solid-svg-icons';


function TemplateCard({ title, icon, color, onLike, liked, onViewClick, saves }) {

  const [saveCount, setSaveCount] = useState(saves);

  const onSaveClick = () => {

    const saved = onLike();

    if (saved) {
    const incrementedCount = saveCount + 1;
    setSaveCount(incrementedCount);
    } else {
      const decrementedCount = saveCount -  1;
    setSaveCount(decrementedCount);
    }

    
  }


  return (
    <div className="community-template-card" style={cardStyle}>
      <div style={iconContainerStyle}>
        <FontAwesomeIcon icon={faFileAlt} size="3x" style={{ color: color }} />
      </div>
      <h3>{title}</h3>
      Kluch Daily
    
      {/* View Button */}
      <button
        style={viewButtonStyle}
        onMouseOver={(e) => (e.target.style.backgroundColor = viewButtonHoverStyle.backgroundColor)}
        onMouseOut={(e) => (e.target.style.backgroundColor = viewButtonStyle.backgroundColor)}
        onClick={onViewClick}
      >
        View Template
      </button>
      <p>{saveCount} {saveCount !== 1 ? "Saves": "Save"}</p>
      <button 
        onClick={onSaveClick} 
        className="like-btn"
        style={liked ? buttonLikedStyle : buttonStyle}
      >
        <FaHeart size={24} color={liked ? 'white' : '#FF6F61'} style={{ marginRight: '10px' }} />
        {liked ? ' Saved' : ' Save'}
      </button>
    </div>
  );
}

export default TemplateCard;

const cardStyle = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  border: '1px solid #ccc',
  borderRadius: '12px', // Slightly rounder corners
  width: '250px',
  padding: '20px',
  textAlign: 'center',
  boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
  backgroundColor: '#fff',
  transition: 'transform 0.3s ease',
  minHeight: '300px',
};

const iconContainerStyle = {
  marginBottom: '15px',
};

// Default button style with a lighter, fresher blue
const buttonStyle = {
  background: 'linear-gradient(145deg, #65aEDD, #4F8ACF)', 
  color: 'white',
  border: 'none',
  padding: '12px 25px',
  borderRadius: '30px',
  cursor: 'pointer',
  fontSize: '1.1em',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.15)',
  transition: 'all 0.3s ease',
  outline: 'none',
};

const buttonHoverStyle = {
  background: 'linear-gradient(145deg, #4F8ACF, #3C6F9D)',
  transform: 'scale(1.05)', 
};

const buttonLikedStyle = {
  ...buttonStyle,
  background: 'linear-gradient(145deg, #FFB6B6, #FF9E9E)', // Softer coral gradient for "liked" state
  color: 'white', 
};




const viewButtonStyle = {
  background: 'linear-gradient(145deg, #F8F8FF, #EDEDED)', 
  color: 'black', 
  border: 'none',
  padding: '12px 25px',
  borderRadius: '30px',
  cursor: 'pointer',
  fontSize: '1.1em',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
  transition: 'all 0.3s ease',
  outline: 'none',
};

const viewButtonHoverStyle = {
  background: 'linear-gradient(145deg, #218838, #1c7430)', 
  transform: 'scale(1.05)', 
};
